
import React from 'react';
import CollapsableCard, { useUpdateCollapsableHeight } from '../CollapsableCard';
import IdfaRequestConfigForm from '../sdk/IdfaRequestConfigForm';

const CollapsableIdfaRequestConfig = ({icon, title, data, closeBtnText, onSave}) => {
  const { ref, active, setActive, collapseHeight, updateHeight } = useUpdateCollapsableHeight()

  return (
    <CollapsableCard
      icon={icon}
      title={title}
      active={active}
      setActive={setActive}
      collapseHeight={collapseHeight}
      closeBtnText={closeBtnText}
      ref={ref}
      >
      <IdfaRequestConfigForm
        idfas_request_config={data}
        inherited_idfas_request_config={data.inherited}
        onHeightChange={()=>(updateHeight())}
        onSave={onSave}
        />
    </CollapsableCard>
  )
}

export default CollapsableIdfaRequestConfig